











































































import { Component, Vue } from 'vue-property-decorator';
import Store from '../store';

declare let apigClientFactory: any;

export default Vue.extend({
  data: () => {
    return {
      isInitiated: false,
      form: {
        username: '',
        password: '',
        error: false,
        errorMessage: '',
      },
      isLoading: false,
      isMFATokenInput: false,
      userMFAToken: "",
    };
  },
  methods: {
    async onSubmit() {
      this.clearStatus();

      if (this.invalidUsername || this.invalidPassword) {
          this.form.error = true;
          this.form.errorMessage = 'Username dan password harus diisi';
          return;
      }

      this.form.error = false;

      this.isLoading = true;

      const params = {
        // This is where any header, path, or querystring request params go.
      };
      // const body = {
      //   // This is where you define the body of the request
      //   username: this.form.username,
      //   password: this.form.password,
      // };
      const body = {
        username: this.form.username,
        userToken: this.userMFAToken,
        password: this.form.password
      }
      const additionalParams = {
      };

      const apigClient = apigClientFactory.newClient();
      // let result = await apigClient.apiV1IdentityLoginPost(params, body, additionalParams)
      apigClient.apiV1IdentityLoginPost(params, body, additionalParams)
        .then((result: any) => {
          console.log('result', result)
          let token = result.data.data.token;

          if (token != null) {
            this.$store.commit('SET_LoggedIn', true);
            this.$store.commit('SET_Token', token);
            this.$store.commit('SET_RefreshToken', result.data.refreshToken)
            this.$store.commit('SET_IsFatchToken', false)
            this.$router.push('/submission');
            // console.log('token', this.$store.getters.getToken());
          } else {
            this.form.error = true;
            this.form.errorMessage = 'Login tidak valid!';
          }
        }).catch((e: any)=>{
          if(e.data.message == "MFA token is required!"){
            this.form.error = true;
            this.form.errorMessage = e.data.message;
            this.isMFATokenInput = true;
          }else{
            this.form.error = true;
            this.form.errorMessage = 'Login tidak valid!';
          }
          console.log(e)
        }).finally(()=>{
          this.isLoading = false;
        })
    },
    clearStatus() {
        this.form.error = false;
    },
  },
  computed: {
    invalidUsername() {
      return this.form.username === '';
    },
    invalidPassword() {
      return this.form.password === '';
    },
  },
  mounted() {
    if (Store.getters.getToken() != null && Store.getters.getToken() != '') {
      this.$router.push('/submission');
    }
  },
});
